const audio = document.getElementById("header_audio");
const btn = document.getElementById("btn_audio");

if (audio) {
    btn.addEventListener("click", () => {
        if (audio.paused) {
        audio.play();
        btn.classList.add("active");
        } else {
        audio.pause();
        btn.classList.remove("active");
        }
    });

    audio.addEventListener("ended", () => {
        btn.classList.remove("active");
    });
}